import {Directus} from '@directus/sdk'

if ([36, 80, 120].indexOf(WC.idMenu) > -1 && WC.idArticolo) {
	getTrailStatus(WC.idArticolo)
}

async function getTrailStatus(artId) {
	const directus = new Directus('https://cms.asiago.it')

	const query = await directus.items('trails').readByQuery({
		fields: [
			'id',
			'article_id',
			'cai_trails',
			'category',
			'status.color',
			'status.translations.name',
			'trail_id',
			'translations.status_notes',
			'updated_on',
		],
		filter: {
			article_id: {
				_eq: artId,
			},
		},
		deep: {
			translations: {
				_filter: {
					Lingua_id: {
						_eq: WC.idLingua,
					},
				},
			},
			status: {
				translations: {
					_filter: {
						Lingua_id: {
							_eq: WC.idLingua,
						},
					},
				},
			},
		},
		limit: 1,
	})

	if (query.data.length !== 1) {
		console.error('Failed to fetch trail data!')
		return
	}

	const data = query.data.map(item => ({
		id: item.id,
		category: item.category,
		trail_id: item.trail_id,
		article_id: item.article_id,
		cai_trails: item.cai_trails,
		status_color: item.status.color,
		status_name: item.status.translations[0]?.name,
		status_notes: item.translations[0]?.status_notes,
		updated_on: item.updated_on,
	}))[0]

	showTrailStatus(data)
}

function showTrailStatus(data) {
	const resources = getResources()

	const article = document.querySelector('.article-full')

	const statusDiv = document.createElement('div')
	statusDiv.classList.add('trailStatus')
	statusDiv.classList.add('trailStatus-escursioni')

	statusDiv.innerHTML += /* html */ `
		<div class="trailHeader">
			<p class="statusText">${autoLang(resources.statusText)}:</p>
			<p class="status" style="color: ${data.status_color}">${data.status_name} *</p>
			<p class="statusNotes" ${data.status_notes ? '' : 'hidden'}>${data.status_notes || ''}</p>
		</div>
		<div class="trailDetails">
			<div class="trailDetail">
				<p class="lastUpdateText">${autoLang(resources.lastUpdateText)}:</p>
				<p class="lastUpdate">${printLastUpdate(data.updated_on)}</p>
			</div>
			<div class="trailDetail" ${data.cai_trails ? '' : 'hidden'}>
				<p class="caiIdText">${autoLang(resources.caiIdText)}:</p>
				<p class="caiTrailId">${data.cai_trails?.join('/')} **</p>
			</div>
			<div class="disclaimers">
				<p class="disclaimer">* ${autoLang(resources.disclaimer)}</p>
				<p class="disclaimer" ${data.cai_trails ? '' : 'hidden'}>** ${autoLang(resources.disclaimerCai)}</p>
			</div>
		</div>
	`

	const referenceNode = article.querySelector('.escursioni')
	referenceNode.appendChild(statusDiv)

	$('.trailStatus .disclaimers').readmore({
		collapsedHeight: 50,
		moreLink: '<a href="#" class="trailStatus__readmore">Leggi tutto</a>',
		lessLink: '<a href="#" class="trailStatus__readmore--less">Comprimi</a>',
	})

	// Print admin__var with trail id
	if (WC.isAdmin) {
		const node = document.createElement('a')
		node.classList.add('admin__var', 'admin__var--trailid')
		node.href = `https://cms.asiago.it/admin/content/trails/${data.id}`
		node.target = '_blank'
		node.textContent = `Trail: ${data.trail_id}`

		document.querySelector('.titoli-cnt').appendChild(node)
	}
}

function getResources() {
	const resources = {
		statusText: {
			it: 'Stato itinerario',
			en: 'Itinerary status',
			de: 'Reiseroutenstatus',
		},
		lastUpdateText: {
			it: 'Ultimo aggiornamento',
			en: 'Last update',
			de: 'Letzte Aktualisierung',
		},
		caiIdText: {
			it: 'Riferimento CAI',
			en: 'CAI Reference',
			de: 'CAI Referenz',
		},
		importantNotes: {
			it:
				'Attenzione! A seguito della tempesta Vaia possono esserci ancora alberi instabili, anche sui percorsi segnalati come <i>Percorribili</i>. Si raccomanda quindi di prestare sempre molta attenzione, di rimanere sui sentieri e di non avventurarsi nel bosco.',
			en:
				'Warning! As a result of the Vaia storm, there may still be unstable trees, even on paths marked as <i>Walkable</i>. It is therefore recommended to always pay close attention, to stay on the trails and not to venture into the woods.',
			de:
				'Warnung! Infolge des Vaia-Sturms kann es auch auf als <i>begehbar</i> gekennzeichneten Wegen noch instabile Bäume geben. Es wird daher empfohlen, immer genau darauf zu achten, auf den Wegen zu bleiben und sich nicht in den Wald zu wagen.',
		},
		disclaimer: {
			it:
				"Sebbene le informazioni siano le più attendibili possibile, lo stato dell'itinerario è da ritenersi indicativo. Nel caso troviate condizioni diverse da quando indicato non esitate a mandarne segnalazione all'indirizzo segnalazioni@asiago.it. Per le escursioni in montagna si raccomanda sempre la massima prudenza. Si declina ogni responsabilità nel caso di danni a persone e cose accaduti percorrendo questo itinerario.",
			en:
				'Although the information is as reliable as possible, the status of the itinerary is indicative. If you find different conditions from when indicated, do not hesitate to send a notification to the address segnalazioni@asiago.it. For mountain excursions it is always recommended to be very careful. No liability is accepted in the event of damage to persons or things that has occurred along this route.',
			de:
				'Obwohl die Informationen so zuverlässig wie möglich sind, ist der Status der Reiseroute indikativ. Wenn Sie andere als die angegebenen Bedingungen feststellen, senden Sie eine Benachrichtigung an die Adresse segnalazioni@asiago.it. Bei Bergtouren ist immer Vorsicht geboten. Für Schäden an Personen oder Sachen, die auf diesem Weg entstanden sind, wird keine Haftung übernommen.',
		},
		disclaimerCai: {
			it:
				"I nostri itinerari non sempre corrispondono con quelli del CAI. Nel caso coincidano del tutto o in parte con uno o più itinerari CAI, qui trovate i riferimenti. Le indicazioni sull'apertura si riferiscono sempre al tratto percorso nel nostro itinerario.",
			en:
				'Our itineraries do not always correspond with those of the CAI. If they coincide in whole or in part with one or more CAI itineraries, here you will find the references. The indications on the opening always refer to the section covered in our itinerary.',
			de:
				'Unsere Reiserouten stimmen nicht immer mit denen des CAI überein. Wenn sie ganz oder teilweise mit einer oder mehreren CAI-Reiserouten übereinstimmen, finden Sie hier die Referenzen. Die Angaben auf der Eröffnung beziehen sich immer auf den Abschnitt in unserer Reiseroute.',
		},
	}

	return resources
}

function autoLang(obj) {
	if (!obj) {
		return ''
	}

	switch (WC.lang) {
		case 'it-IT':
			return obj.it
		case 'en-GB':
			return obj.en
		case 'de-DE':
			return obj.de
	}
}

function printLastUpdate(lastUpdate) {
	const friendlyHour = new Date(lastUpdate)

	if (friendlyHour.getHours() + friendlyHour.getMinutes() + friendlyHour.getSeconds() === 0) {
		return friendlyHour.toLocaleDateString()
	} else {
		return friendlyHour.toLocaleString()
	}
}
